export default function() {
  /* 表格列头：统一用 min-width，剩余宽度按内容长度比例分配，整行铺满、间隔均匀 */
  return [
    { label: "序号", type: "index", minWidth: 80 },
    { label: "是否禁用", prop: "disable", slots: "disable", minWidth: 110 },
    { label: "openid", prop: "openid", slots: "openid", minWidth: 260 },
    { label: "手机号", prop: "phone", minWidth: 160 },
    {
      label: "登录时间",
      prop: "create_time",
      minWidth: 190,
    },
    {
      label: "操作",
      prop: "operation",
      minWidth: 120,
      slots: "operation",
    },
  ];
}
